export default class VerordnungMonitoringDto {

  constructor(json) {
    if (json) {
      this.json = json
      this.id = json.id;
      this.srNummer = json.srNummer;
      this.art = json.art;
      this.geltungsdauerVon = json.geltungsdauerVon;
      this.geltungsdauerBis = json.geltungsdauerBis;
      this.status = json.status;
      this.link = json.link;
    } else {
      this.json = {}
    }
  }

  get kontArt() {
    return 'art.' + this.art.toLowerCase()
  }
}
